import { render, staticRenderFns } from "./GenericInput.vue?vue&type=template&id=07fa0d0f&scoped=true"
import script from "./GenericInput.vue?vue&type=script&lang=js"
export * from "./GenericInput.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07fa0d0f",
  null
  
)

export default component.exports